import {
  GET_RESOURCE_GROUP_REQUEST,
  GET_RESOURCE_GROUP_SUCCESS,
  GET_RESOURCE_GROUP_FAILURE,
  // GET_DOWNLOAD_RESOURCE_GROUP_REQUEST,
  // GET_DOWNLOAD_RESOURCE_GROUP_SUCCESS,
  // GET_DOWNLOAD_RESOURCE_GROUP_FAILURE,
  UPDATE_RESOURCE_GROUP_REQUEST,
  UPDATE_RESOURCE_GROUP_SUCCESS,
  UPDATE_RESOURCE_GROUP_FAILURE,
  DELETE_RESOURCE_GROUP_REQUEST,
  DELETE_RESOURCE_GROUP_SUCCESS,
  DELETE_RESOURCE_GROUP_FAILURE,
  CREATE_NEW_RESOURCE_GROUP_REQUEST,
  CREATE_NEW_RESOURCE_GROUP_SUCCESS,
  CREATE_NEW_RESOURCE_GROUP_FAILURE,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE,
} from "./resourceGroupScreenTypes";

const initialState = {
  loading: false,
  resourceGroup: [],
  error: "",
};

const getResourceGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RESOURCE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RESOURCE_GROUP_SUCCESS:
      return {
        loading: false,
        resourceGroup: action.payload,
        error: "",
      };
    case GET_RESOURCE_GROUP_FAILURE:
      return {
        loading: false,
        resourceGroup: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// const initialStateDownload = {
//   loading: false,
//   resourceGroup: [],
//   error: "",
// };

// const getDownloadRsourceGroupReducer = (
//   state = initialStateDownload,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOWNLOAD_RESOURCE_GROUP_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOWNLOAD_RESOURCE_GROUP_SUCCESS:
//       return {
//         loading: false,
//         resourceGroup: action.payload,
//         error: "",
//       };
//     case GET_DOWNLOAD_RESOURCE_GROUP_FAILURE:
//       return {
//         loading: false,
//         resourceGroup: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

const initialStateForUpdate = {
  loading: false,
  resourceGroup: {},
  error: "",
};

const updateResourceGroupReducer = (state = initialStateForUpdate, action) => {
  switch (action.type) {
    case UPDATE_RESOURCE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_RESOURCE_GROUP_SUCCESS:
      return {
        loading: true,
        resourceGroup: action.payload,
        error: "",
      };
    case UPDATE_RESOURCE_GROUP_FAILURE:
      return {
        loading: false,
        resourceGroup: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDelete = {
  loading: false,
  resourceGroup: {},
  error: "",
};

const deleteResourceGroupReducer = (state = initialStateForDelete, action) => {
  switch (action.type) {
    case DELETE_RESOURCE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_RESOURCE_GROUP_SUCCESS:
      return {
        loading: true,
        resourceGroup: action.payload,
        error: "",
      };
    case DELETE_RESOURCE_GROUP_FAILURE:
      return {
        loading: false,
        resourceGroup: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCreate = {
  loading: false,
  newResourceGroup: {},
  error: "",
};

const createNewResourceGroupReducer = (
  state = initialStateForCreate,
  action
) => {
  switch (action.type) {
    case CREATE_NEW_RESOURCE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_NEW_RESOURCE_GROUP_SUCCESS:
      return {
        loading: true,
        newResourceGroup: action.payload,
        error: "",
      };
    case CREATE_NEW_RESOURCE_GROUP_FAILURE:
      return {
        loading: false,
        newResourceGroup: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForLocations = {
  loading: false,
  locations: [],
  error: "",
};

const getLocationsForResourceGroupReducer = (
  state = initialStateForLocations,
  action
) => {
  switch (action.type) {
    case GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS:
      return {
        loading: false,
        locations: action.payload,
        error: "",
      };
    case GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE:
      return {
        loading: false,
        locations: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getResourceGroupReducer,
  // getDownloadRsourceGroupReducer,
  updateResourceGroupReducer,
  deleteResourceGroupReducer,
  createNewResourceGroupReducer,
  getLocationsForResourceGroupReducer,
};
